import styled, { keyframes } from 'styled-components'

const fadein = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`

const Container = styled.div`
  animation: ${fadein} 2s;
  h2 {
    margin: 12px 0 4px;
  }
  p {
    margin-bottom: 8px;
  }

  p a {
    font-family: inherit;
    color: ${props => props.theme.cores[ 'TAG1-700' ]};
    text-decoration: underline;
    &:hover {
      color: ${props => props.theme.cores[ 'TAG1-400' ]};
    }
  }
`

export { Container }
